import { AuthService } from '../auth/auth.service';
import { LanguageService } from '../shared/services/language.service';
import { TrendService } from './trend.service';

import { DatexPipe } from '../shared/datex.pipe';

import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

import { TranslatePipe } from '@ngx-translate/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';

export const MODULES = [CommonModule, MatCardModule];
export const PIPES = [TranslatePipe, DatexPipe];

@Component({
  selector: 'app-trend',
  templateUrl: './trend.component.html',
  styleUrls: ['./trend.component.scss'],
  imports: [...MODULES, ...PIPES, FaIconComponent],
})
export class TrendComponent implements OnInit {
  private auth = inject(AuthService);
  private trendService = inject(TrendService);
  public languageService = inject(LanguageService);

  customerDocument;
  trendAreaIdsToRequest: Array<number>; // holds all areaIds of trendProducts in customerDocument
  trendData = signal<any[]>(undefined); // holds the data received from API

  translationOfIdsAndNames = signal({}); // holds all id's and corresponding areaNames

  ngOnInit(): void {
    this.customerDocument = this.auth.getCustomerDocument();
    this.trendAreaIdsToRequest = this.getTrendAreaIdsFromCostumerDocument(
      this.customerDocument
    );
    this.requestAreaIdsFromApi(this.trendAreaIdsToRequest);
  }

  getTrendAreaIdsFromCostumerDocument(customerDocument: object): Array<number> {
    const trendProducts = customerDocument['trendProducts'];
    const trendProductsInCustomerDocument = [];

    for (const product of trendProducts) {
      if (this.auth.isProductActive('trendProducts', product.id)) {
        trendProductsInCustomerDocument.push(product.areaId);
        // adds id & corresponding name to object, needed to translate it later in html
        this.translationOfIdsAndNames.update(translationOfIdsAndNames => {
          return {
            ...translationOfIdsAndNames,
            [product.areaId]: product.overwriteName,
          };
        });
      }
    }
    return trendProductsInCustomerDocument;
  }

  requestAreaIdsFromApi(trendAreaIdsToRequest: Array<number>) {
    this.trendData.set([]);
    for (const singleAreaId of trendAreaIdsToRequest) {
      this.trendService.getTrendDataForAreaId(singleAreaId).subscribe(
        data => {
          // checking needed because: API delivers {trendTextObject: null} when no data for areaId is available
          if (data['trendTextObject'] !== null) {
            this.trendData.update(trendData => {
              return [...trendData, data['trendTextObject']];
            });
          }
        },
        err => {
          console.log('Error in trend component requesting data:', err);
        }
      );
    }
  }
}
